import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { OrderItemResponse, OrderResponse } from '../../models/order/order-response.model';
import { ConfigurationService } from '../../services/configuration.service';
import { OrderService } from '../../services/order.service';
import { ItemCart } from '../../interfaces/itemCart.interface';
import { ModalController } from '@ionic/angular';
import { V2ItemPage } from 'src/app/shared/components/v2/v2-item/v2-item.page';
import { ToastaddService } from 'src/app/services/toastadd.service';
import { PaymentService } from 'src/app/services/payment.service';
import { cardConsumo } from 'src/app/models/payment/consumo.model';
import { Utils } from 'src/app/shared/util';

@Component({
  selector: 'app-conta',
  templateUrl: './conta.page.html',
  styleUrls: ['./conta.page.scss'],
})
export class ContaPage {

  /**
   * Items pedidos pela mesa/ficha
   */
  items$: Observable<OrderItemResponse[]>
  /**
   * Pedidos realizados pela ficha
   */
  ordersByFicha$: Observable<OrderResponse>
  /**
   * Modo de execução do app
   */
  appMode$: Observable<string>
  saldoCartao$: Observable<cardConsumo>
  showConsulta: boolean = false;
  saldo: any
  card: any
  restImagem: any
  logoZimmer: any
  cardCliente: {
    cartaoid: any,
    cpf:      any,
    nro:      any,
    saldo:    any,
    validade: any
  }

  constructor(
    private config: ConfigurationService,
    private modalCtrl: ModalController,
    private orderService: OrderService,
    private alerta: ToastaddService,
    private payment: PaymentService,
    private utils: Utils
  ) { 
    this.saldo='R$ 10,00'
    this.logoZimmer = 'assets/v2/logo_zimmer.png'
    this.restImagem = this.config.imagemRest.imagem != null ? this.config.imagemRest.imagem : this.logoZimmer
       
    
  }

  ionViewDidEnter() {
    this.items$ = this.orderService.getItemsOrderedByTableNumber()
    this.appMode$ = this.config.getMode().pipe(tap(v => console.log(v)))
    this.ordersByFicha$ = this.orderService.getOrderByComandaId()
    if(this.config.modoApp = 'consumo'){
      this.config.isConsumo = true
    }
  }

  callItemPage(item: ItemCart) {
    item.number = 1
    this.modalCtrl.create({
      component: V2ItemPage,
      componentProps: {
        itemCart: item,
        replay: true
      },
      cssClass: 'modal-fullscreen'
    }).then(modal => modal.present())
  }

  voltar(){
    this.config.isConsumo = false
    this.showConsulta = false
    this.card = undefined
  }

  consultaSaldo(){

    if(this.card === undefined){
      this.alerta.alertaMsg('Preencha o número do cartao')
      return
    }
    this.utils.setStateLoading(true)
    
    const restid = this.config.restauranteId
    const nroCard = this.card
    try{
        this.saldoCartao$ = this.payment.getSaldoConsumo(restid,nroCard)
        this.saldoCartao$.subscribe(data => {
                    
          if(data != null){
            this.cardCliente = {
              cartaoid: data.cartaoConsumoId,
              cpf:      data.cpf,
              nro:      data.numero,
              saldo:    data.saldoAtual,
              validade: data.validade
            }
            this.utils.setStateLoading(false)
            this.showConsulta = true  
          }else{
            this.alerta.alertaMsg('Cartão inexistente ou não cadastrado')
            this.utils.setStateLoading(false)
          }
                   
        })
                                     
    }catch{
      this.utils.setStateLoading(false)
    }
    
  }
}
